import * as actionTypes from "../../actions/actionTypes";

const initialState = {
  allPatients: [],
  myPatients: [],
  allNotes: [],
  totalNotePages: 1,
  searchNotes: [],
  searchValue: "",
  curImages: [],
  currentData: {},
  allFiles: [],
  searchFiles: [],
  searchFileValue: "",
  allPrescriptions: [],
  searchPrescriptions: [],
  searchPrescriptionValue: "",
  totalPatientPages: 1,
  totalFilePages: 1,
};

const patients = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PATIENTS:
      return { ...state, ...action.payload };
    case actionTypes.SEARCH_PATIENT:
      return {
          ...state,
          searchedPatients: action.search,
          searchedPatientsValue: action.searchValue,
          total_pages: action.total_pages,
        };
    case actionTypes.GET_PATIENT: {
      const patients = [...state?.allPatients, ...state?.myPatients];

      const patient = patients.find(
        patient => patient.id === parseInt(action.id)
      );
      return { ...state, patient };
    }
    case actionTypes.SET_PATIENT_PROFILE: {
      return { ...state, patient: action.payload };
    }
    case actionTypes.GET_PATIENT_NOTES:
      return {
        ...state,
        allNotes: [...action.payload],
        totalNotePages: action.total_pages,
      };
    case actionTypes.SEARCH_PATIENT_NOTES:
      return {
        ...state,
        totalNotePages: action.total_pages,
        searchValue: action.searchValue,
      };
    case actionTypes.EMPTY_PATIENT_DATA:
      return {
        ...state,
        totalNotePages: 1,
        allNotes: [],
      };
    case actionTypes.SET_CURRENT_NOTE_IMAGES:
      return { ...state, curImages: [...action.payload] };
    case actionTypes.SET_CURRENT_NOTE_DATA:
      return {
        ...state,
        currentData: { ...state.currentData, ...action.payload },
      };
    case actionTypes.CLEAR_CURRENT_NOTE_DATA:
      return {
        ...state,
        currentData: {},
      };
    case actionTypes.DELETE_SCREENSHOT: {
      const images = [...state.currentData.notesImages];

      const updatedImages = images.filter(img => img !== action.payload);

      return {
        ...state,
        currentData: {
          ...state.currentData,
          notesImages: updatedImages,
        },
      };
    }
    case actionTypes.SET_PATIENT_FILES:
      return {
        ...state,
        allFiles: [...action.payload.allFiles],
        totalFilePages: action.payload.total_pages,
      };
    case actionTypes.SEARCH_PATIENT_FILES:
      return {
        ...state,
        totalFilePages: action.total_pages,
        searchFiles: action.search,
        searchFileValue: action.searchValue,
      };
    case actionTypes.EMPTY_PATIENT_FILES:
      return {
        ...state,
        searchFileValue: "",
        searchFiles: [],
        allFiles: [],
        totalFilePages: 1,
      };
    case actionTypes.SET_PATIENT_PRESCRIPTIONS:
      return {
        ...state,
        allPrescriptions: [...action.payload.allPrescriptions],
      };
    case actionTypes.SEARCH_PATIENT_PRESCRIPTIONS:
      return {
        ...state,
        searchPrescriptions: action.search,
        searchPrescriptionValue: action.searchValue,
      };
    case actionTypes.EMPTY_PATIENT_PRESCRIPTIONS:
      return {
        ...state,
        searchPrescriptionValue: "",
        searchPrescriptions: [],
        allPrescriptions: [],
      };
    case actionTypes.EMPTY_PATIENT_LIST:
      return {
        ...state,
        totalPatientPages: 1,
        searchValue: undefined,
        searchedPatients: undefined,
      };
    default:
      return state;
  }
};

export default patients;
